import ky from 'ky';

export const LegacyCoopClient = ky.create({
  prefixUrl: '/api/coop',
  credentials: 'include',
  // 30 seconds
  timeout: 1000 * 30,
  // Retries are also handled by the React Query Client
  retry: 0,
});
